import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styles from './DropdownMenuElemToggle.module.scss';
import Toggle from '../../Toggle/Toggle';
import cn from 'classnames';
import Paragraph from '../../Typography/Paragraph/Paragraph';
const DropdownMenuElemToggle = ({ label, onClick, checked, className, color }) => {
    return (_jsxs("button", Object.assign({ onClick: onClick, className: cn('d-flex align-items-center justify-content-between', styles.element, className) }, { children: [label && _jsx(Paragraph, { color: color, fontFamily: 'urbanist', title: label }), _jsx(Toggle, { checked: checked })] })));
};
export default DropdownMenuElemToggle;
